import React, { useEffect, useState } from "react";
import style from "./data-basic.module.css";

import CreateIcon from "@mui/icons-material/Create";
import LockIcon from "@mui/icons-material/Lock";
import { Recycling } from "@mui/icons-material";

import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import CropOutlinedIcon from "@mui/icons-material/CropOutlined";
import ParkOutlinedIcon from "@mui/icons-material/ParkOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

function DataBasic({ plot, parcelas }) {
  const [inputEdit, setInputEdit] = useState(false);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user")).user
  );
  const [region, setRegion] = useState(localStorage.getItem("region"));
  const [date, setDate] = useState("");
  const [faseForest, setFaseForest] = useState("");
  const [area, setArea] = useState("");
  const [rotation, setRotation] = useState("");
  const [ugb, setUgb] = useState();
  const [material, setMaterial] = useState("");

  const handleChangeDate = () => {
    let date = new Date();

    let day = date.getDate().toString();
    let month = (date.getMonth() + 1).toString();
    let year = date.getFullYear().toString();

    let dateComplete = `${day.padStart(2, "0")}/${month.padStart(
      2,
      "0"
    )}/${year.padStart(4, "0")}`;
    setDate(dateComplete);
  };

  function getWeekOfMonth() {
    let date = new Date();

    let dayOfMonth = date.getDate();
    let dayOfWeek = date.getDay();
    let weekOfMonth = Math.ceil((dayOfMonth + 6 - dayOfWeek) / 7);

    setRotation(weekOfMonth);
  }

  useEffect(() => {
    handleChangeDate();
    getWeekOfMonth();
  }, []);

  return (
    <div className={style["card"]}>
      <div className={style["title-card"]}>Dados Básicos</div>
      <div className={style["body-card"]}>
        <div className={style["left-column-card"]}>
          <div>
            <div className={style["main-container"]}>
              <div className={style["ball"]}>
                <MapOutlinedIcon style={{ color: "#40a8c4" }} />
              </div>
              <div className={style["text"]}>{plot.region}</div>
            </div>
          </div>
          <div>
            <div className={style["main-container"]}>
              <div className={style["ball"]}>
                <CropOutlinedIcon style={{ color: "#40a8c4" }} />
              </div>
              <div className={style["text"]}>{plot.area}</div>
            </div>
          </div>
        </div>
        <div className={style["right-column-card"]}>
          <div>
            <div className={style["main-container"]}>
              <div className={style["ball"]}>
                <RoomOutlinedIcon style={{ color: "#40a8c4" }} />
              </div>
              <div className={style["text"]}>{plot.ugb}</div>
            </div>
          </div>
          <div>
            <div className={style["main-container"]}>
              <div className={style["ball"]}>
                <ParkOutlinedIcon style={{ color: "#40a8c4" }} />
              </div>
              <div className={style["text"]}>{plot.material}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={style["information-blocked"]}>
        <div>
          <div className={style["main-container"]}>
            <div className={style["ball"]}>
              <CalendarMonthOutlinedIcon style={{ color: "#40a8c4" }} />
            </div>
            <div className={style["text"]}>{date}</div>
          </div>
        </div>
        <div>
          <div className={style["main-container"]}>
            <div className={style["ball"]}>
              <PersonOutlineOutlinedIcon style={{ color: "#40a8c4" }} />
            </div>
            <div className={style["text"]}>{user}</div>
          </div>
        </div>
      </div>
      {parcelas != null && (
        <div className={style["information-blocked"]} style={{ marginTop: "10px" }}>
          <div>
            <div className={style["main-container"]}>
              <div className={style["ball"]}>
                <Recycling style={{ color: "#40a8c4" }} />
              </div>
              <div className={style["text"]}>
                {plot.area ? `${plot.area} Ha = ${parcelas} parcela${parcelas !== 1 ? "s" : ""}` : `${parcelas} parcela${parcelas !== 1 ? "s" : ""}`}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DataBasic;
